import { Injectable, inject } from '@angular/core';

import { TotalsPrefix } from '@cds/betting-offer';
import { EventOption } from '@frontend/sports/betting-offer/feature/model';
import { EpcotConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';

import { OptionNameStrategy } from './option-name.strategy';

@Injectable({ providedIn: 'root' })
export class MarketAttributeOptionNameStrategy extends OptionNameStrategy {
    private sitecore = inject(Sitecore);
    private epcot = inject(EpcotConfig);

    override getOptionName(option: EventOption): string {
        return !this.epcot.isEnabled && option.marketAttribute
            ? option.marketAttribute
            : option.totalsPrefix
              ? `${this.preFix(option.totalsPrefix)} ${option.marketAttribute}`
              : option.optionAttribute || option.marketAttribute || '';
    }

    private preFix(totalsPrefix: TotalsPrefix): string {
        return totalsPrefix === TotalsPrefix.Over ? this.sitecore.eventGrid.SixPack_TotalsOver : this.sitecore.eventGrid.SixPack_TotalsUnder;
    }
}
